import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface SearchBoxProps {
  compact?: boolean;
  defaultValue?: string;
}

export default function SearchBox({ compact = false, defaultValue = "" }: SearchBoxProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(defaultValue);
  const [focused, setFocused] = useState(false);

  const currentKeyword = new URLSearchParams(location.search).get("q") || "";

  useEffect(() => {
    if (location.pathname === "/search") {
      setValue(currentKeyword);
    }
  }, [location.pathname, currentKeyword]);

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) {
      navigate("/search");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  return (
    <form onSubmit={submit} role="search" className="w-full">
      <div
        className={`flex items-center gap-2 rounded-md border bg-background-50 pl-3 pr-1.5 transition-colors ${
          focused ? "border-primary-400" : "border-background-300"
        } ${compact ? "h-9" : "h-11"}`}
      >
        <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
          <i className={`${compact ? "ri-search-line text-sm" : "ri-search-line text-base"}`} />
        </span>
        <input
          type="search"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={compact ? "搜索动漫…" : "搜索动漫名称、题材、地区…"}
          aria-label="搜索动漫"
          className={`flex-1 bg-transparent outline-none text-foreground-900 placeholder:text-foreground-400 ${
            compact ? "text-[13px]" : "text-sm"
          }`}
        />
        <button
          type="submit"
          className={`rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer flex items-center justify-center whitespace-nowrap ${
            compact ? "h-7 px-2.5 text-[12px]" : "h-8 px-4 text-sm"
          }`}
        >
          {compact ? <i className="ri-arrow-right-line" /> : "搜索"}
        </button>
      </div>
    </form>
  );
}